import React from 'react';
import { connect, useDispatch } from 'react-redux';

import { Button } from '~/eds/src/components/Button/Button';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';
import { ManageSyncPairStageType } from '~/enums/ManageSyncPairStageType';
import { useIntl } from 'react-intl';
import { slices } from '~/redux/slices';

function EmptySyncPairsPlaceholder() {
  const intl = useIntl();
  const dispatch = useDispatch();

  return (
    <Layout
      align="center"
      direction="column"
      justify="center"
      p={16}
      spacing={6}
      borderRadius="m"
      border="border.divider"
    >
      <Text color="text.secondary">
        {intl.formatMessage({
          id: 'EmptySyncPairsPlaceholder.noSyncPairs',
          defaultMessage: 'No sync pairs yet',
          description:
            'Message displayed when there are no sync pairs configured',
        })}
      </Text>
      <Button
        text={intl.formatMessage({
          id: 'EmptySyncPairsPlaceholder.addSyncPair',
          defaultMessage: 'Add Sync Pair',
          description: 'Button text to add a new sync pair',
        })}
        variant="primary"
        onClick={() =>
          dispatch(
            slices.integrations.actions.setManageSyncPairStage(
              ManageSyncPairStageType.ProviderProcurements,
            ),
          )
        }
      />
    </Layout>
  );
}

export default connect(null)(EmptySyncPairsPlaceholder);
